<template>
  <Form ref="distributorsForm" :model="distributorsForm" :rules="ruleValidate" :label-width="120"
    :disabled="distributorsType === 'look'" @submit.native.prevent>
    <Row>
      <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
        <Form-item :label="$t('key1003098')" prop="name">
          <Input clearable v-model.trim="distributorsForm.name"></Input>
        </Form-item>
      </Col>
      <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
        <Form-item :label="$t('key1003099')" prop="contacts">
          <Input clearable v-model.trim="distributorsForm.contacts"></Input>
        </Form-item>
      </Col>
      <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
        <Form-item :label="$t('key1003100')" prop="mobile">
          <Input type="text" clearable v-model.trim="distributorsForm.mobile" :placeholder="$t('key1003101')">
            <Select slot="prepend" v-model="distributorsForm.mobileCountryCode" filterable transfer class="reset_select_input">
              <Option v-for="(item, index) in countrysBasisData" :value="item.twoCode" :key="index">{{ item.areaCodeName }}</Option>
            </Select>
          </Input>
        </Form-item>
      </Col>
      <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
        <Form-item :label="$t('key1001175')">
          <Input clearable v-model.trim="distributorsForm.phone"></Input>
        </Form-item>
      </Col>
      <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
        <Form-item :label="$t('key1000068')" prop="email">
          <Input clearable v-model.trim="distributorsForm.email"></Input>
        </Form-item>
      </Col>
      <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
        <Form-item :label="$t('key1003102')" prop="distributorCurrency">
          <Select v-model.trim="distributorsForm.distributorCurrency" filterable transfer class="w-250">
            <Option v-for="item in distributorCurrencyList" :label="item.currencyNameCode" :value="item.targetCurrencyCode">{{ item.currencyNameCode }}</Option>
          </Select>
        </Form-item>
      </Col>
      <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
        <Form-item prop="password">
          <template #label>
            <label>{{ $t('key1002791') }}</label>
          </template>
          <div class="generateStyle">
            <Input clearable style="width: 58%;" :element-id="'distributorsForm_password'" v-model.trim="distributorsForm.password"></Input>
            <Button type="primary" style="margin-left: 12px;" @click="getStrongPassword('distributorsForm', 'password')">{{ $t('key1002792') }}</Button>
          </div>
        </Form-item>
      </Col>
      <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-if="showProductWholesaleModel">
        <Form-item :label="$t('key1003103')" prop="distributorType" class="radio_styles">
          <RadioGroup v-model="distributorsForm.distributorType">
            <Radio v-for="item in businessTypeList" :label="item.value">{{ item.name }}</Radio>
          </RadioGroup>
        </Form-item>
      </Col>
      <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
        <Form-item :label="$t('key1003104')" prop="ymsDistributorMerchantGradeId">
          <Select v-model="distributorsForm.ymsDistributorMerchantGradeId" filterable transfer style="width:250px">
            <Option v-for="(item, index) in distributorlevelList" :value="item.ymsDistributorMerchantGradeId" :key="index">{{ item.name }}</Option>
          </Select>
        </Form-item>
      </Col>
      <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
        <Form-item :label="$t('key1003105')" prop="ymsDistributorWarehouseOperList">
          <CheckboxGroup v-model="distributorsForm.ymsDistributorWarehouseOperList">
            <Checkbox v-for="item in warehouseList" :label="item.ymsWarehouseId" :key="item.ymsWarehouseId">{{ item.name }}</Checkbox>
          </CheckboxGroup>
        </Form-item>
      </Col>
      <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
        <Form-item :label="$t('key1003106')" prop="merchantType" class="radio_styles">
          <RadioGroup v-model="distributorsForm.merchantType">
            <Radio label="YMS">{{ $t('key1003107') }}</Radio>
            <Radio label="ALIGJ">{{ $t('key1003108') }}</Radio>
          </RadioGroup>
        </Form-item>
      </Col>
    </Row>
  </Form>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from "@/api";
import {getDataSetBatchList, getEnumList} from "@/utils/common";

export default {
  name: "distributorsForm",
  mixins: [Mixin],
  props: {
    distributorsType: {
      type: String,
      default: 'look'
    },
    countrysBasisData: {
      type: Array,
      default: () => []
    },
    // 是否开启批发模式
    showProductWholesaleModel: {
      type: Boolean,
      default: false
    }
  },
  data() {
    let v = this;
    return {
      distributorsForm: {
        name: '', // 客户名称
        contacts: '', // 联系人
        mobile: '', // 手机号
        phone: '', // 电话
        email: '', // 邮箱
        password: '', // 密码
        mobileCountryCode: 'CN',
        distributorCurrency: '',
        ymsDistributorMerchantGradeId: null,
        ymsDistributorWarehouseOperList: [],
        merchantType: 'YMS',
        distributorType: 'retail', // 业务类型
      },
      ruleValidate: {  // 新增客户(非通途商户)字段必填的校验
        ymsDistributorMerchantGradeId: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003097'), trigger: 'change'}
        ],
        mobile: [
          {validator: v.validateOverseasMobile(false), trigger: 'blur'}
        ],
        password: [
          {required: true, validator: v.password(), trigger: 'blur'}
        ]
      },
      distributorlevelList: [],
      distributorCurrencyList: [],
      warehouseList: [],
      enumData: []
    };
  },
  computed: {
    // 业务类型
    businessTypeList() {
      const ENUM_KEY = 'YmsDistributorMerchantDetailDistributorTypeCoreEnum';
      return getEnumList(this.enumData, ENUM_KEY);
    }
  },
  created() {
    this.distributorsForm.mobileCountryCode = 'CN';
  },
  methods: {
    // 校验密码
    password() {
      let v = this;
      return function (rule, value, callback) {
        if (!value && v.distributorsType !== 'edit') {
          return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000143')));
        } else {
          callback();
        }
      };
    },
    async init() {
      let enumKeyList = ['YmsDistributorMerchantDetailDistributorTypeCoreEnum'];
      this.enumData = await getDataSetBatchList(enumKeyList);
      await this.systemCurrencyData();
      if (this.distributorCurrencyList.some(i => i.targetCurrencyCode === 'CNY')) {
        this.distributorsForm.distributorCurrency = 'CNY';
      } else {
        this.distributorsForm.distributorCurrency = this.distributorCurrencyList[0].targetCurrencyCode;
      }
    },
    async systemCurrencyData() {
      let v = this;
      const {data} = await v.axios.get(api.get_ymsCurrencyConfig_query + `?merchantType=3`);
      const {code, datas} = data;
      if (code === 0) {
        v.distributorCurrencyList = datas.map((item) => {
          item.currencyNameCode = item.currencyName + ' ' + item.targetCurrencyCode;
          return item;
        });
      }
      return true;
    },
  }
};
</script>

<style lang="less" scoped>
.generateStyle {
  display: flex;
  align-items: center;

  .ivu-input {
    width: 100% !important;
  }
}

/deep/ .reset_select_input {
  width: 100px;
  line-height: 35px;
  height: 35px;
  display: flex;
  align-items: center;

  .ivu-select-selection {
    height: 35px;
  }
}

/deep/ .ivu-input-group-prepend {
  background-color: transparent;
}

/deep/ .ivu-checkbox-group-item {
  display: inline-block;
  margin-right: 30px;
}

.w-250 {
  width: 250px;
}
</style>
